/**
 * registratieService — zelfregistratie van een nieuw bedrijf.
 *
 * Een nieuw bedrijf ontstaat in EEN batch: het locatiedocument en het
 * beheerdersprofiel tegelijk. De beveiligingsregels eisen die koppeling
 * (getAfter over en weer), zodat niemand een profiel kan maken dat naar
 * andermans locatie wijst. Los schrijven wordt dus geweigerd; dat is geen
 * bug maar het slot op de deur.
 */

import { db } from '../firebase';
import { doc, writeBatch } from 'firebase/firestore';

// De bedrijfsnaam wordt het document-id van de locatie, en document-id's
// kennen harde grenzen ('/', '.', '..'). Daarnaast is 'global' verboden,
// want library/global is de gedeelde laag van de leverancier.
// Letters (ook accenten), cijfers, spatie, koppelteken en underscore.
const NAAM_PATROON = /^[\p{L}\p{N}][\p{L}\p{N} _-]{1,39}$/u;

export function valideerBedrijfsnaam(naam) {
    const schoon = (naam || '').trim();
    if (schoon.length < 2) {
        return { ok: false, fout: 'Gebruik minimaal 2 tekens.' };
    }
    if (schoon.length > 40) {
        return { ok: false, fout: 'Gebruik maximaal 40 tekens.' };
    }
    if (schoon.toLowerCase() === 'global') {
        return { ok: false, fout: 'Deze naam is gereserveerd, kies een andere.' };
    }
    if (!NAAM_PATROON.test(schoon)) {
        return { ok: false, fout: 'Gebruik letters, cijfers, spaties, - of _.' };
    }
    return { ok: true, naam: schoon };
}

/**
 * Maakt in een batch de locatie en het beheerdersprofiel aan.
 * Gooit bij een bestaande bedrijfsnaam een permission-denied, want create
 * op een bestaand document bestaat niet en dan faalt de hele batch.
 */
export async function registreerBedrijf({ uid, email, bedrijfsnaam, gebruikersnaam }) {
    const controle = valideerBedrijfsnaam(bedrijfsnaam);
    if (!controle.ok) throw new Error(controle.fout);
    const naam = controle.naam;

    const wie = (gebruikersnaam || '').trim() || (email ? email.split('@')[0] : uid);
    const nu = new Date().toISOString();

    const batch = writeBatch(db);
    batch.set(doc(db, 'locations', naam), {
        name: naam,
        ownerUid: uid,
        createdAt: nu
    });
    batch.set(doc(db, 'users', uid), {
        uid,
        email: email || null,
        username: wie,
        role: 'admin',
        allowedLocations: [naam],
        createdAt: nu
    });
    await batch.commit();
    return naam;
}
